import { forwardRef } from 'react'

interface SvgProps {
  className?: string
}

const Play = forwardRef<SVGSVGElement, SvgProps>(({ className }, ref) => {
  return (
    <svg
      ref={ref}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 11.9862C21 12.2465 20.9115 12.4579 20.7344 12.6205C20.5573 12.7832 20.4688 12.8645 20.4688 12.8645L5.92578 21.6797C5.39453 22.0267 4.94076 22.0917 4.56445 21.8749C4.18815 21.658 4 21.2243 4 20.5738V3.43125C4 2.78068 4.18815 2.34697 4.56445 2.13011C4.94076 1.91326 5.39453 1.96747 5.92578 2.29276L20.4688 11.1405C20.4688 11.1405 20.5573 11.2218 20.7344 11.3845C20.9115 11.5471 21 11.7477 21 11.9862Z"
        fill="currentColor"
      />
    </svg>
  )
})

export default Play

Play.displayName = 'Play'
